import React from 'react'
import { createRoot } from 'react-dom/client'
import ConsultationFormModal from 'components/TeamPublicPage/ConsultationFormModal'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('teams-browse-container') ||
                    document.getElementById('team-cards-container')
  if (!container) return

  const consultationTeams = JSON.parse(container.dataset.consultationTeams || '{}')
  const currentUser = JSON.parse(container.dataset.currentUser || 'null')
  const consultationTranslations = JSON.parse(container.dataset.consultationTranslations || '{}')
  const ownTeamIds = new Set(JSON.parse(container.dataset.ownTeamIds || '[]'))

  const modalContainer = document.getElementById('consultation-modal-root')
  if (!modalContainer) return

  let consultationRoot = null

  function renderConsultationModal(teamId, memberId, isOpen) {
    if (!consultationRoot) {
      consultationRoot = createRoot(modalContainer)
    }
    const teamData = consultationTeams[teamId] || {}
    consultationRoot.render(
      React.createElement(ConsultationFormModal, {
        isOpen,
        onClose: () => renderConsultationModal(teamId, memberId, false),
        onSubmitted: (_result, { hasBooking } = {}) => {
          renderConsultationModal(teamId, memberId, false)
          showSuccessBanner(hasBooking)
        },
        teamId: parseInt(teamId, 10),
        teamSlug: teamData.slug || '',
        fields: teamData.intakeFormFields || [],
        colors: { primary: '#3366FF' },
        currentUser,
        translations: consultationTranslations,
        consultationEnabled: teamData.consultationEnabled || false,
        consultationDuration: teamData.consultationDuration || 30,
        userTimezone: currentUser?.timezone,
        previousResponses: null,
        memberId: memberId ? parseInt(memberId, 10) : null
      })
    )
  }

  function showSuccessBanner(hasBooking) {
    const ct = consultationTranslations?.consultation || {}
    const successText = hasBooking
      ? (ct.join_success || '預約諮詢成功！記得準時出席')
      : (ct.join_success_no_booking || '已送出！團長收到通知後會回覆你')
    let banner = document.getElementById('consultation-success-banner')
    if (!banner) {
      banner = document.createElement('div')
      banner.id = 'consultation-success-banner'
      banner.className = 'mb-6 bg-green-50 border border-green-200 rounded-xl px-5 py-4 flex items-center gap-3'
      const list = document.getElementById('teacher-list') || document.getElementById('team-list')
      if (list) list.parentNode.insertBefore(banner, list)
    }
    // Use DOM APIs instead of innerHTML to avoid XSS if translations ever become user-editable.
    banner.replaceChildren()
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    icon.setAttribute('class', 'w-5 h-5 text-green-500 flex-shrink-0')
    icon.setAttribute('fill', 'none')
    icon.setAttribute('stroke', 'currentColor')
    icon.setAttribute('viewBox', '0 0 24 24')
    icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />'
    const msg = document.createElement('span')
    msg.className = 'text-green-800 font-medium'
    msg.textContent = successText
    banner.appendChild(icon)
    banner.appendChild(msg)
    banner.classList.remove('hidden')
    banner.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  window.openConsultationModal = function (teamId, memberId) {
    if (ownTeamIds.has(teamId)) {
      const ct = consultationTranslations?.consultation || {}
      alert(ct.owner_hint || '這是學生用的聯繫功能，品牌成員無法對自己的品牌諮詢。')
      return
    }
    renderConsultationModal(teamId, memberId, true)
  }
})
